import React from 'react';
import { Box, SvgIcon } from '@mui/material';
import { borderRadius, customSizes, palette } from '../../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../../utils/getMuiIcon';
import { GeneratedArtifactType } from '@klab-berlin/api-sdk/lib/types/responses/Ai';
import { colors } from '../../../../../assets/styles/themes/variables';

interface ArtifactCardAvatarProps {
  type: GeneratedArtifactType;
}

const baseAvatarBoxSx = {
  width: customSizes.artifactCard.avatarSize,
  height: customSizes.artifactCard.avatarSize,
  borderRadius: borderRadius.sm,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const documentAvatarBoxSx = { ...baseAvatarBoxSx, bgcolor: palette.info.contrastText };
const imageAvatarBoxSx = { ...baseAvatarBoxSx, bgcolor: colors.mustard50 };
const podcastAvatarBoxSx = { ...baseAvatarBoxSx, bgcolor: colors.violet50 };

const ICON_SIZE = customSizes.artifactCard.iconSize;
const documentIconSx = { width: ICON_SIZE, height: ICON_SIZE, color: palette.info.dark };
const imageIconSx = { width: ICON_SIZE, height: ICON_SIZE, color: colors.mustard400 };
const podcastIconSx = { width: ICON_SIZE, height: ICON_SIZE, color: colors.violet500 };

const AVATAR_VARIANTS = {
  [GeneratedArtifactType.DOCUMENT]: {
    iconName: 'documentArtifact' as const,
    boxSx: documentAvatarBoxSx,
    iconSx: documentIconSx,
  },
  [GeneratedArtifactType.IMAGE]: {
    iconName: 'imageArtifact' as const,
    boxSx: imageAvatarBoxSx,
    iconSx: imageIconSx,
  },
  [GeneratedArtifactType.PODCAST]: {
    iconName: 'audioArtifact' as const,
    boxSx: podcastAvatarBoxSx,
    iconSx: podcastIconSx,
  },
};

const ArtifactCardAvatar: React.FC<ArtifactCardAvatarProps> = ({ type }) => {
  const { iconName, boxSx, iconSx } =
    AVATAR_VARIANTS[type] ?? AVATAR_VARIANTS[GeneratedArtifactType.DOCUMENT];

  return (
    <Box sx={boxSx}>
      <SvgIcon component={getMuiIcon(iconName)} sx={iconSx} viewBox='0 0 24 24' aria-hidden='true' />
    </Box>
  );
};

export default ArtifactCardAvatar;
